module.exports = __webpack_public_path__ + "img/map1_bg.c549d052.svg";